// iOS Safari exposes no Vibration API (navigator.vibrate is undefined), so a
// toggled <input switch> is the only web-exposed way to emit a haptic tap on
// iPhone (17.4+). Callers try navigator.vibrate first (Android) and fall back
// to this. It MUST be invoked inside the tap gesture to fire.
let _switch = null;

function getSwitch() {
  if (typeof document === "undefined") return null;
  if (_switch) return _switch;
  try {
    const label = document.createElement("label");
    label.setAttribute("aria-hidden", "true");
    Object.assign(label.style, {
      position: "fixed", left: "-9999px", top: "0",
      width: "1px", height: "1px", opacity: "0", pointerEvents: "none",
    });
    const input = document.createElement("input");
    input.type = "checkbox";
    input.setAttribute("switch", "");
    label.appendChild(input);
    document.body.appendChild(label);
    _switch = label;
  } catch (e) {
    _switch = null;
  }
  return _switch;
}

export function iosHaptic() {
  try {
    const el = getSwitch();
    if (el) el.click();
  } catch (e) {
    /* no-op */
  }
}
